import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

import { useCountryName } from "../../../../components/AddressInput/hooks";

export function PositionLocationSummaryField({
  field,
}: {
  field: components["schemas"]["PositionOrPropertyLocationCheckField"];
}) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();

  const showAddressSection =
    field?.value?.location_type === "Position Location";

  const locationTypeLabel: Record<
    components["schemas"]["LocationTypeEnum"],
    string
  > = {
    "Gig Location": t("Gig Location"),
    "Property Location": t("Property Location"),
    "Position Location": t("Position Location"),
  };

  return (
    <>
      <InnerContentItem
        label={t("Location type")}
        testID="location-summary-location-type"
      >
        {field?.value?.location_type
          ? locationTypeLabel[field.value.location_type]
          : t("Not provided")}
        <br />
      </InnerContentItem>
      {showAddressSection && (
        <InnerContentItem
          label={t("Office or work address")}
          testID="location-summary-office-work-address"
        >
          {field?.value?.address || t("Address not provided")}
          <br />
          {field?.value?.city || t("City not provided")},{" "}
          {field?.value?.province_state || t("Province/state not provided")}{" "}
          {field?.value?.country
            ? getCountryName(field.value.country)
            : t("Country not provided")}
          <br />
          {field?.value?.postal_code || t("Postal code not provided")}
          <br />
        </InnerContentItem>
      )}
    </>
  );
}
